import React, { useEffect, useState } from "react";

interface ToastMessageProps {
  message: string;
  visible: boolean;
  onClose: () => void;
}

const ToastMessage: React.FC<ToastMessageProps> = ({
  message,
  visible,
  onClose,
}) => {
  const [show, setShow] = useState(visible);

  useEffect(() => {
    setShow(visible);
    if (visible) {
      const timer = setTimeout(() => {
        onClose(); // Call onClose to signal that the toast should be hidden
      }, 3000); // Adjust the duration as needed

      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  if (!show) return null;

  return (
    //NB! Placeholder-component. To be implemented as part of NNNW-378
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        backgroundColor: "red",
        color: "white",
        padding: "10px",
        borderRadius: "5px",
        zIndex: 1000,
      }}
    >
      {message}
    </div>
  );
};

export default ToastMessage;
